import {SearchOutlined} from '@ant-design/icons'
import InputText from '@/components/Form/InputText.jsx'
import {useOpenModal} from '@/components/Modal'
import {useReadOnly} from '@/components/Form/ReadOnly.mjs'
import SelectUvTemplateDialog from '@/pages/MainPage/dialogs/SelectUvTemplateDialog.jsx'

const defaultValue = {}

export default function SelectUvTemplate({
    className,
    style,
    disabled,
    readOnly,
    value = defaultValue,
    onChange,
    ...props
}) {
    const openModal = useOpenModal()
    const gReadOnly = useReadOnly()

    const handleClickInput = async () => {
        if (! readOnly || ! gReadOnly) {
            const ut = await openModal(
                <SelectUvTemplateDialog umUiLayoutType={value.layoutTypeId} />
            )

            if (ut) {
                const {name: utName, pkid: utId} = ut
                onChange({utId, utName})
            }
        }
    }

    const icon = readOnly || gReadOnly ?
        null
        :
        <SearchOutlined
            disabled={disabled}
            onClick={handleClickInput}
        />

    return (
        <div
            className={className}
            style={style}
            onKeyDown={e => e.stopPropagation()}
            {...props}
        >
            <InputText
                addonAfter={icon}
                allowClear
                disabled={disabled}
                readOnly
                value={value.utName}
                onClick={handleClickInput}
            />
        </div>
    )
}
